<template>

  <div class="user">

    <!--添加商家-->
    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick" v-auth="'/plus/activity/activity/add'">添加活动</el-button>
    </div>
    
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="">
          <el-select v-model="formInline.status" placeholder="活动状态">
            <el-option label="全部状态" value="-1"></el-option>
            <el-option v-for="(item,index) in status" :key="index" :label="item" :value="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-input v-model="formInline.title" placeholder="请输入活动标题"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="title" label="活动标题" ></el-table-column>
            <el-table-column prop="categorya.name" label="活动分类" >
              <template slot-scope="scope">
                <span v-if="scope.row.categorya" >{{ scope.row.categorya.name}}</span>
                <span v-else >无分类</span>
              </template>
              
            </el-table-column>
            <el-table-column prop="start_time_text" label="开始时间" width="150"></el-table-column>
            <el-table-column prop="end_time_text" label="结束时间" width="150"></el-table-column>
            <el-table-column prop="status_text" label="活动状态" width="120"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button  @click="openPopup(scope.row,'activity')" type="text" size="small">页面链接</el-button>
                <el-button @click="detailClick(scope.row)" type="text" size="small">报名详情</el-button><br />
                <el-button @click="browseClick(scope.row)" type="text" size="small">浏览记录</el-button><br />
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button><br />
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
           :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
    <!--页面链接-->
    <LinkPage v-if="show_path" :is_open="show_path" :path_type="path_type" :dataModel="dataModel" @closeDialog="closeDialogFunc($event)"></LinkPage>
  </div>
</template>

<script>
import activityApi from '@/api/activity.js';
import LinkPage from '@/components/page/path';
export default {
  components: {
    LinkPage
  },
  inject: ['reload'],
  data() {
    return {
      show_path:false,
      path_type:'',
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      form: {},
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {},
      formInline: {},
      status: ['未开始', '进行中', '已结束'],
    };
  },
  created() {

    /*获取列表*/
    this.getTableList();
  },
  methods: {
    /*关闭弹窗*/
    closeDialogFunc(e) {
        this.show_path = e.openDialog;
    },
    openPopup(item,type){
        this.dataModel = item;
        this.dataModel.wxapp_id = this.wxapp_id;
        this.show_path = true;
        this.path_type = type;
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      activityApi.activityList(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          console.log(self.tableData)
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {});
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },

    /* 活动详情 */
    detailClick(row){
      let activity_id = row.activity_id;
       this.$router.push({
        path: '/plus/activity/activity/detail',
        query: {
          activity_id: activity_id,
          title:row.title
        }
      });
    },

    /* 浏览记录 */
    browseClick(row){
      let activity_id = row.activity_id;
       this.$router.push({
        path: '/plus/activity/activity/browse',
        query: {
          activity_id: activity_id
        }
      });
    },

    /*添加活动*/
    addClick() {
      this.$router.push('/plus/activity/activity/add');
    },

    /*编辑活动*/
    editClick(row) {
      let activity_id = row.activity_id;
      this.$router.push({
        path: '/plus/activity/activity/edit',
        query: {
          activity_id: activity_id
        }
      });
    },

    /*删除*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          activityApi.delActivity(
            {
              activity_id: row.activity_id
            },
            true
          )
            .then(data => {
              if (data.code == 1) {
                self.$message({
                  message: '删除成功',
                  type: 'success'
                });
                this.onSubmit();
              } else {
                self.$message.error('错了哦，这是一条错误消息');
              }
            })
            .catch(error => {});
        })
        .catch(() => {});
    },
    
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/activity/activity/index.vue